<template>
  <section
    :style="data.style ? data.style :  isDark ? 'secondary' : ''"
    :class="`${isDark ? 'secondary white--text' : ''}  ${data.class}`"
    id="pricing"
  >
    <v-container :fluid="$vuetify.breakpoint.name==='md' ? true :false" class="py-12">
      <v-row justify="space-around" class="mb-2">
        <h1
          :class="isDark?'page-heading white--text text--darken-3' : 'page-heading grey--text text--darken-3'"
        >{{data.title}}</h1>
      </v-row>

      <v-row justify="center" v-if="data.cycle_labels.month && data.cycle_labels.year">
        <v-radio-group
          v-model="cycle"
          :row="$vuetify.breakpoint.name==='xs' ? false : true"
          :dark="isDark"
        >
          <v-radio :label="data.cycle_labels.month" value="month" color="primary"></v-radio>
          <v-radio :label="data.cycle_labels.year" value="year" color="primary"></v-radio>
        </v-radio-group>
      </v-row>

      <v-row justify="center" align="center">
        <v-col cols="11" sm="7" md="4" lg="4" xl="3" class v-for="(item,i) in data.items" :key="i">
          <v-card class="hover-tile" tile>
            <v-card-title class="py-6 white--text" :style="item.title_style">
              <v-spacer></v-spacer>
              <h3>{{item.title}}</h3>
              <v-spacer></v-spacer>
              <div class="ribbon ribbon-top-right" v-if="item.best_value">
                <span>Best Value</span>
              </div>
            </v-card-title>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" class="text-center">
                  <div>
                    <span
                      style="font-size:36px"
                      class="primary--text"
                    >${{cycle === 'year' ? (item.cycle[cycle].price/12).toFixed(2) : item.cycle[cycle].price}}</span>
                    <span v-if="cycle==='month'">/month</span>
                    <span v-if="cycle==='year'">/month</span>
                  </div>
                  <div class="caption">
                    <span class="grey--text">${{ item.cycle[cycle].price}}/year</span>
                  </div>
                </v-col>
              </v-row>
            </v-container>
            <v-divider></v-divider>
            <v-container class="py-0">
              <v-row>
                <v-col cols="12">
                  <div class style="line-height:33px" v-html="item.features"></div>
                </v-col>
              </v-row>
            </v-container>
            <v-card-actions v-if="item.button.text" class="pb-4">
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                v-if="item.button.url"
                :to="item.button.url"
              >{{item.button.text}}</v-btn>
              <v-btn
                color="primary"
                v-else
                @click="selectMembership(item.type)"
              >{{item.button.text}}</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-row justify="center" v-if="data.footer_button.url && data.footer_button.text">
        <v-col cols="12" class="text-center py-6">
          <transition appear name="bounce" v-on:appear="customAppearHook">
            <v-btn color="primary" :to="data.footer_button.url">{{data.footer_button.text}}</v-btn>
          </transition>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "PagePricing",
  props: ["value"],
  data() {
    return {
      cycle: "year"
    };
  },
  created() {
    setTimeout(
      function() {
        if (this.$route.hash === "#pricing") {
          this.$vuetify.goTo("#pricing", {
            duration: 300,
            offset: 100,
            easing: "easeInOutCubic"
          });
        }
      }.bind(this),
      300
    );
  },
  computed: {
    data() {
      return this.value;
    },
    isDark() {
      return this.value.dark ? true : false;
    }
  },
  methods: {
    customAppearHook() {
      console.log("customAppearHook");
    },
    selectMembership(type) {
      this.$emit("selected", {
        type: type,
        cycle: this.cycle
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/* common */
.ribbon {
  width: 130px;
  height: 130px;
  overflow: hidden;
  position: absolute;
}
.ribbon::before,
.ribbon::after {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
}
.ribbon span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 0px 0;
  background-color: #000000;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #fff;
  font-size: 12px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  text-transform: uppercase;
  text-align: center;
}

/* top right*/
.ribbon-top-right {
  top: 0px;
  right: 0px;
}
.ribbon-top-right::before,
.ribbon-top-right::after {
  border-top-color: transparent;
  border-right-color: transparent;
}
.ribbon-top-right::before {
  top: 0;
  left: 0;
}
.ribbon-top-right::after {
  bottom: 0;
  right: 0;
}
.ribbon-top-right span {
  left: -25px;
  top: 25px;
  transform: rotate(45deg);
}

.plus-gradient {
  background: rgb(0, 187, 236);
  background: linear-gradient(
    135deg,
    rgba(0, 187, 236, 1) 0%,
    rgba(79, 209, 245, 1) 50%,
    rgba(144, 84, 255, 1) 100%
  );
}
</style>